import {
  CloseOutlined,
  DownloadOutlined,
  ExclamationCircleOutlined,
  ExportOutlined,
} from '@ant-design/icons';
import {
  Avatar,
  Button,
  Checkbox,
  Divider,
  Modal,
  Progress,
  Radio,
  Select,
  Space,
  Spin,
  Typography,
  message,
} from 'antd';
import { useState } from 'react';
import colors from '../../../../constants/ColourConstants';
import TextArea from 'antd/es/input/TextArea';
import axios from 'axios';
import API from '../../../../services/apiConfig';

export default function ExportPyoutModal({
  open,
  setOpen,
  n,
  count,
  query,
  selected,
  handleExportCSV,
}) {
  const { Text } = Typography;
  const [exportType, setexportType] = useState('selected');
  const [LargeFile, setLargeFile] = useState(false);
  const [exportProgress, setExportProgress] = useState(false);
  const [completedModel, setCompletedModel] = useState(false);
  const [progress, setProgress] = useState(0);
  const [downloading, setDownloading] = useState(false);
  const [fileSize, setFileSize] = useState('');

  const fileName = `payout_export_${new Date().toISOString().split('T')[0]}.csv`;

  const formatBytes = (bytes) => {
    if (bytes === 0 || bytes === undefined) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  // const startDownload = async () => {
  //   setDownloading(true);
  //   setProgress(0);
  //   let payload =
  //     exportType === 'selected' ? { keys: selected.toString() } : query;

  //   try {
  //     const response = await API.get('/payouts/exportCsv', {
  //       params: payload,
  //       withCredentials: true,
  //       responseType: 'blob',
  //       onDownloadProgress: (event) => {
  //         const percent = Math.floor((event.loaded / event.total) * 100);
  //         setProgress(percent);
  //         setFileSize(formatBytes(event.total));
  //       },
  //     });
  //     const url = window.URL.createObjectURL(new Blob([response.data]));
  //     const link = document.createElement('a');
  //     link.href = url;
  //     link.setAttribute('download', fileName);
  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();

  //     message.success('Download completed!');
  //   } catch (error) {
  //     message.error('Download failed.');
  //     setTimeout(() => setExportProgress(false), 1000);
  //   } finally {
  //     setDownloading(false);
  //   }
  // };

  const handleOk = () => {
    setOpen(false);
    if (
      (exportType === 'selected' && n > 1000) ||
      (exportType === 'query' && count > 1000)
    ) {
      setLargeFile(false);
    }
    setExportProgress(true);
    // startDownload();
    handleExportCSV(exportType);
  };

  return (
    <>
      <Modal
        title="Export Payouts"
        open={open}
        onCancel={() => setOpen(false)}
        footer={[
          <Button key="back" onClick={() => setOpen(false)}>
            Cancel
          </Button>,
          <Button
            disabled={exportType === 'selected' && n <= 0}
            key="submit"
            type="primary"
            onClick={() => {
              handleOk();
            }}
          >
            Start Export
          </Button>,
        ]}
        centered
      >
        <Divider style={{ marginTop: 0 }} />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <Text style={{ fontWeight: 600, fontSize: '14px' }}>Scope</Text>
        </div>
        <Radio.Group
          onChange={(e) => setexportType(e.target.value)}
          defaultValue={'selected'}
          value={exportType}
          style={{
            display: 'flex',
            flexDirection: 'column',
            margin: '8px 0',
            gap: 4,
          }}
        >
          <Radio value={'selected'}>{`Selected Rows (${n} rows)`}</Radio>
          <Radio value={'query'}>{`Filtered Results (${count} rows)`}</Radio>
        </Radio.Group>
      </Modal>

      {/*------next ------
       <Modal
        title="Export in progress..."
        open={exportProgress}
        footer={null}
        onCancel={() => {
          setExportProgress(false);
        }}
        closeIcon={<CloseOutlined />}
        centered
      >
        <Divider style={{ marginTop: 0 }} />
        <div style={{ margin: '8px 16px' }}>
          <div style={{ margin: '0px 40px' }}>
            {LargeFile && (
              <div>
                <Spin />
                <Text>{`You’re exporting ${(exportType === 'selected' && n) || (exportType === 'query' && count)} rows`}</Text>
              </div>
            )}
            <Progress percent={progress} strokeColor="#23979A" />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginTop: 24 }}>
            <Avatar
              size="large"
              style={{ backgroundColor: '#E9FAF9', color: '#23979A' }}
              icon={<ExportOutlined rotate={90} />}
            />
            <Space direction="vertical" size={0} style={{ marginLeft: 12 }}>
              <Text strong>{fileName}</Text>
              <Text type="secondary">
                {fileSize} &nbsp;•&nbsp;{' '}
                {progress < 100 ? 'Exporting...' : 'Completed'}
              </Text>
            </Space>
            <CloseOutlined
              style={{ marginLeft: 'auto', color: '#999', cursor: 'pointer' }}
              onClick={() => {
                setExportProgress(false);
              }}
            />
          </div>
        </div>
      </Modal> */}

      {/* <Modal
        width={'45%'}
        open={showConfirmModal}
        title={
          <>
            <ExclamationCircleOutlined style={{ color: colors.colorWarning }} />
            <Text style={{ marginLeft: 8 }}>Confirm Status Update</Text>
          </>
        }
        onCancel={() => {
          setShowConfirmModal(false);
          setOpen(true);
        }}
        footer={[
          <Button
            key="back"
            onClick={() => {
              setShowConfirmModal(false);
              setOpen(true);
            }}
          >
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              handleOnOk(invoiceUpdateType, newStatus);
            }}
          >
            Confirm
          </Button>,
        ]}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            marginLeft: '25px',
          }}
        >
          <Text>
            You&apos;re about to update{' '}
            <Text strong>
              {invoiceUpdateType == 'selected' ? n : count} payouts
            </Text>{' '}
            {newStatus.update_status && `based on your selected status.`}
          </Text>
          {newStatus.update_status && (
            <Text>
              <ul
                style={{
                  paddingLeft: 20,
                  marginBottom: 0,
                  listStyleType: 'disc',
                }}
              >
                <li style={{ marginBottom: 8 }}>
                  Change status to <Text strong>{newStatus.status}</Text>
                </li>
              </ul>
            </Text>
          )}
          {newStatus.update_notes && (
            <Text>
              <ul
                style={{
                  paddingLeft: 20,
                  marginBottom: 0,
                  listStyleType: 'disc',
                }}
              >
                <li style={{ marginBottom: 8 }}>
                  Add note:<Text strong>{`"${newStatus.notes}"`}</Text>
                </li>
              </ul>
            </Text>
          )}
          <Text>Do you want to proceed?</Text>
        </div>
      </Modal> */}
    </>
  );
}

// import React, { useState } from 'react';
// import { Button, Progress, message } from 'antd';
// import axios from 'axios';

// const FileDownloader = () => {
//   const [progress, setProgress] = useState(0);
//   const [downloading, setDownloading] = useState(false);

//   const downloadFile = async () => {
//     setDownloading(true);
//     setProgress(0);

//     try {
//       const response = await axios.get(
//         'http://localhost:8080/api/payouts/exportCSV',
//         {
//           responseType: 'blob',
//           onDownloadProgress: (event) => {
//             const percent = Math.floor((event.loaded / event.total) * 100);
//             setProgress(percent);
//           },
//         },
//       );

//       // Create a link and trigger the download
//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement('a');
//       link.href = url;
//       link.setAttribute('download', 'file.pdf'); // Change the file name if needed
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       message.success('Download completed!');
//     } catch (error) {
//       message.error('Download failed!');
//       console.error(error);
//     } finally {
//       setDownloading(false);
//     }
//   };

//   return (
//     <div style={{ width: 300 }}>
//       <Button type="primary" onClick={downloadFile} disabled={downloading}>
//         {downloading ? 'Downloading...' : 'Download File'}
//       </Button>
//       {downloading && (
//         <Progress
//           percent={progress}
//           status="active"
//           style={{ marginTop: 16 }}
//         />
//       )}
//     </div>
//   );
// };

// export default FileDownloader;
